enum ContentTagTypes {
  General = "GENERAL",
  Drill = "DRILL",
  HealthAndSafety = "HEALTH_AND_SAFETY",
}

export default ContentTagTypes;
